import { useTranslation } from 'react-i18next';

const montserrat = { fontFamily: 'Montserrat, sans-serif' };

function AboutYJSection() {
    const { t } = useTranslation('landing');

    return (
        <section className="w-full bg-white py-12 sm:py-16 lg:py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
                    <div className="lg:col-span-7">
                        <span
                            className="text-xs uppercase tracking-widest mb-4 block text-[#979797]"
                            style={montserrat}
                        >
                            {t('about.eyebrow')}
                        </span>
                        <h2
                            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-6 sm:mb-8"
                            style={montserrat}
                        >
                            {t('about.title')}
                        </h2>
                        <div
                            className="space-y-5 text-gray-600 text-base sm:text-lg leading-relaxed"
                            style={montserrat}
                        >
                            <p>{t('about.paragraph1')}</p>
                            <p>{t('about.paragraph2')}</p>
                        </div>
                    </div>

                    <div className="lg:col-span-5">
                        <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 sm:p-8 space-y-6">
                            <div className="flex gap-4">
                                <div className="flex-shrink-0 w-1 rounded-full bg-green-600" aria-hidden="true" />
                                <p className="text-gray-800 text-base sm:text-lg font-medium leading-relaxed" style={montserrat}>
                                    {t('about.highlightSince')}
                                </p>
                            </div>
                            <div className="border-t border-gray-200" />
                            <div className="flex gap-4">
                                <div className="flex-shrink-0 w-1 rounded-full bg-green-600" aria-hidden="true" />
                                <p className="text-gray-700 text-base leading-relaxed" style={montserrat}>
                                    {t('about.highlightMission')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutYJSection;
